






































































import moment from "moment";
import Vue from "vue";

// vuex
import { mapGetters } from "vuex";

// Vue components
import LocaleDateTimeTooltip from "@/components/LocaleDateTimeTooltip.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetServiceCountersCommand, GetServiceCountersReqData } from "@/model/communication/componentsMaintenance/GetServiceCountersCommand";
import { servCountValueMeaningLabel } from "@/model/data/componentsMaintenance/ServiceCounter";
import { GetMachineMaintenanceStatusIconColor, MaintenanceStatusEnum, MaintenanceStatusEnumToLabel } from "@/model/data/status/MaintenanceStatusEnum";

export default Vue.extend({
    components: {
        LocaleDateTimeTooltip,
    },
    data() {
        return {
            moment,
            MaintenanceStatusEnum,
            loading: false,
            serviceCounters: [],
            headers: [
                {
                    text: this.$t("componentsMaintenance.partName"),
                    value: "partName",
                },
                {
                    text: this.$t("componentsMaintenance.partNumber"),
                    value: "partNumber",
                },
                {
                    text: this.$t("componentsMaintenance.valueMeaning"),
                    value: "valueMeaning",
                },
                {
                    text: this.$t("componentsMaintenance.maxCounter"),
                    value: "maxCounter",
                },
                {
                    text: this.$t("componentsMaintenance.threshold"),
                    value: "threshold",
                },
                {
                    text: this.$t("componentsMaintenance.nextMaintenanceDate"),
                    value: "nextMaintenanceDate",
                },
            ],
            completeFormatThreshold: null,
            monthYearFormatThreshold: null,
        };
    },
    props: ["machine"],
    computed: {
        ...mapGetters(["longDateFormat"]),
    },
    watch: {
        machineSerialNumber() {
            this.getServiceCounters();
        },
    },
    methods: {
        MaintenanceStatusEnumToLabel,
        servCountValueMeaningLabel,
        getIconColor(status: MaintenanceStatusEnum) {
            return GetMachineMaintenanceStatusIconColor(status);
        },

        async getServiceCounters() {
            try {
                this.loading = true;
                let res = await new GetServiceCountersCommand(new GetServiceCountersReqData(this.machine.machineInstallationName, this.machine.machineSerialNumber)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) this.serviceCounters = res.serviceCounters;
                else console.error("cannot fetch available branches");
                this.loading = false;
            } catch (e) {
                console.error("Server error method getServiceCounters() inst: ", this.machine.machineInstallationName, " machine: ", this.machine.machineSerialNumber);
                this.loading = false;
            }
        },
        customSort(items, index, isDesc) {
            let descending = false;
            if (isDesc && isDesc.length > 0) descending = isDesc[0];
            items.forEach((item) => {
                if (!this.isForecastingAvailable(item)) item.nextMaintenanceDate = new Date(5000, 11);
                if (item.maintenanceStatus == MaintenanceStatusEnum.MaintenanceRequired) item.nextMaintenanceDate = new Date(2000, 1);
            });
            items.sort((a, b) => {
                if (index.includes("nextMaintenanceDate")) {
                    if (!descending) return this.compare(a.nextMaintenanceDate, b.nextMaintenanceDate);
                    else return this.compare(b.nextMaintenanceDate, a.nextMaintenanceDate);
                } else if (index.length > 0) {
                    if (!descending) return a[index[0]] < b[index[0]] ? -1 : 1;
                    else return b[index[0]] < a[index[0]] ? -1 : 1;
                }
            });
            return items;
        },
        compare(a: string, b: string): number {
            if (moment(a).isBefore(b)) return -1;
            if (moment(a).isAfter(b)) return 1;
            if (moment(a).isSame(b)) return 0;
        },
        isForecastingAvailable(item) {
            return item.isForecastingAvailable && item.countPerDay != null && item.countPerDay > 0 && item.thresholdFound && item.threshold;
        },
        getLabelForForecastedDate(forecastedLabel) {
            let forecastedDate = moment(forecastedLabel);
            if (forecastedDate < this.completeFormatThreshold) return forecastedDate.format(this.longDateFormat(false, true, true, true));
            if (forecastedDate < this.monthYearFormatThreshold) return forecastedDate.format(this.longDateFormat(false, true, true, true, true, false, true));
            return this.$t("common.notDueSoon");
        },
        formatHopperCurrency(hopperName: string) {
            let hopperNameSplitted = hopperName.split(" ");
            if (hopperNameSplitted.length == 3) return `Hopper ${hopperNameSplitted[2]} ${hopperNameSplitted[1]}`;
            return hopperName;
        },
    },
    mounted() {
        let currentDate = new Date();
        this.completeFormatThreshold = new Date(currentDate.setMonth(currentDate.getMonth() + 2));
        this.monthYearFormatThreshold = new Date(currentDate.setMonth(currentDate.getMonth() + 12));
        this.getServiceCounters();
    },
});
